function isEmpty(obj) {
  return Object.keys(obj).length === 0
}

var component = {
  props: ['collection'],
  data: function data () {
    return {
      shadow: [],
      placeholder: {}
    }
  },
  mounted: function mounted () {
    var this$1 = this;
    
    this.$watch('collection', function (next) {
      var unregister = this$1.$watch(
        'placeholder',
        function (updated) {
          console.info('Updating');
          if (!isEmpty(updated)) {
            unregister();
            if (next) {
              next.push(this$1.placeholder);
              this$1.placeholder = {};
            }
          }
        }, 
        { deep: true }
      );
      this$1.shadow = next ? next.concat(this$1.placeholder) : [ this$1.placeholder ];
    }, { immediate: true });
  },  
  template: "\n<div>\n  <div v-for=\"(item, index) in shadow\">\n    <slot :item=\"item\" :last=\"index === shadow.length - 1\" :index=\"index\"/>\n  </div>\n</div>\n"
};

export default component;
